import { Button, HStack, Text } from '@chakra-ui/react';
import { RefreshCw } from 'lucide-react';
import { useAtomValue } from 'jotai';
import { useT } from '../i18n';
import { updateNow, updateRequiredAtom } from '../lib/updateRequired';

/**
 * The server asked this app to update (any HTTP 426, #82): a banner that
 * stays, never blocks, and reloads into the new version. Reading goes on.
 */
export function UpdateRequiredBanner() {
  const required = useAtomValue(updateRequiredAtom);
  const t = useT();
  if (!required) return null;
  // The catalog's words; the server's message only if there were none.
  const title = t('common.updateRequired.title') || required.message || '';
  return (
    <HStack
      role="status"
      data-testid="update-required"
      bg="accent.tint"
      color="ink"
      px={4}
      py={2}
      spacing={3}
      flexShrink={0}
    >
      <Text flex="1" fontSize="14px" fontWeight={600}>
        {title}
      </Text>
      <Button
        size="sm"
        colorScheme="brand"
        leftIcon={<RefreshCw size={14} aria-hidden="true" />}
        onClick={updateNow}
        flexShrink={0}
      >
        {t('common.updateRequired.action')}
      </Button>
    </HStack>
  );
}
